/* tslint:disable */
import { OnChanges, OnInit } from '@angular/core';
import { MappingService } from './mapping.service';
import { FormBuilder, Validators } from '@angular/forms';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { NotificationService } from '../../shared/notification.service';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';
var MappingComponent = /** @class */ (function () {
    function MappingComponent(mappingService, msisdnService, dialog, fb, notify) {
        this.mappingService = mappingService;
        this.msisdnService = msisdnService;
        this.dialog = dialog;
        this.fb = fb;
        this.notify = notify;
        this.editMode = [];
        this.showBlock = false;
    }
    MappingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mappingForm = this.createForm();
        this.prepareForm();
        this.setProjectNumber();
        this.updateProjectNumbers.subscribe(function (numbers) {
            _this.msisdnsList = numbers.campaignsMsisdns;
            _this.prepareForm();
        });
        this.callerType = this.setTypeIfExist();
        this.callerType && (this.showBlock = true);
    };
    MappingComponent.prototype.setTypeIfExist = function () {
        if (this.mappingEnabled) {
            return 'multiselect';
        }
        else if (this.callerIdRandomChoiceEnabled) {
            return 'shuffle';
        }
        else {
            null;
        }
    };
    MappingComponent.prototype.createForm = function () {
        return this.fb.array([this.createMapping()]);
    };
    MappingComponent.prototype.setProjectNumber = function () {
        var _this = this;
        this.msisdnService.projectNumbers(this.campaignId).subscribe(function (msisdnsList) {
            _this.msisdnsList = msisdnsList.campaignsMsisdns;
        });
    };
    MappingComponent.prototype.createMapping = function (mappingItem) {
        if (mappingItem === void 0) { mappingItem = {}; }
        return this.fb.group({
            id: mappingItem.id || null,
            isoCountry: [mappingItem.isoCountry || null, Validators.required],
            msisdnId: [mappingItem.msisdnId || '', Validators.required],
            pattern: [mappingItem.pattern || '', [Validators.required, this.isPresentIsoCodeAndPattern]],
            callerIdLabel: mappingItem.callerIdLabel || '',
            callerIdCountryCode: mappingItem.callerIdCountryCode || ''
        });
    };
    MappingComponent.prototype.onChangeMapping = function (selectValue) {
        var _this = this;
        this.mappingService.enableMapping(this.campaignId, selectValue).subscribe(function () {
            _this.mappingEnabled = !_this.mappingEnabled;
        });
    };
    MappingComponent.prototype.addMapping = function (form) {
        var _this = this;
        this.mappingService.addNewMapping(this.campaignId, form.getRawValue()).subscribe(function () {
            _this.notify.open('MAPPING.MESSAGES.ADD');
            form.reset();
            _this.prepareForm();
        });
    };
    MappingComponent.prototype.editMapping = function (form) {
        var _this = this;
        this.mappingService.editMapping(this.campaignId, form.getRawValue()).subscribe(function () {
            _this.notify.open('MAPPING.MESSAGES.EDIT');
            _this.prepareForm();
        });
    };
    MappingComponent.prototype.prepareForm = function () {
        var _this = this;
        this.mappingService.mapping(this.campaignId).subscribe(function (mapping) {
            _this.mappingForm.controls = [_this.mappingForm.controls[0]];
            _this.editMode = [];
            mapping.forEach(function (el) {
                _this.mappingForm.controls.push(_this.createMapping(el));
            });
        });
    };
    MappingComponent.prototype.onChangeShuffle = function (selectValue) {
        var _this = this;
        this.mappingService.enableShuffle(this.campaignId, selectValue).subscribe(function () {
            _this.callerIdRandomChoiceEnabled = !_this.callerIdRandomChoiceEnabled;
        });
    };
    MappingComponent.prototype.onChangeEditMode = function (id) {
        this.editMode[id] = true;
    };
    MappingComponent.prototype.selectType = function (type) {
        this.callerType = type;
        this.isMultiSelect ? this.onChangeMapping(true) : this.onChangeShuffle(true);
    };
    Object.defineProperty(MappingComponent.prototype, "isMultiSelect", {
        get: function () {
            return this.callerType === 'multiselect';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MappingComponent.prototype, "isShuffle", {
        get: function () {
            return this.callerType === 'shuffle';
        },
        enumerable: true,
        configurable: true
    });
    MappingComponent.prototype.toggleShowBlock = function () {
        this.showBlock = !this.showBlock;
        if (!this.showBlock) {
            this.callerType = '';
            this.disableAll();
        }
    };
    MappingComponent.prototype.disableAll = function () {
        this.onChangeMapping(false);
        this.onChangeShuffle(false);
    };
    MappingComponent.prototype.onDelete = function (mappingId) {
        var _this = this;
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'MAPPING.MODAL.HEADER',
                body: 'MAPPING.MODAL.BODY'
            }
        })
            .afterClosed()
            .subscribe(function (confirm) {
            if (confirm) {
                _this.mappingService.remove(_this.campaignId, mappingId).subscribe(function () {
                    _this.prepareForm();
                });
            }
        });
    };
    MappingComponent.prototype.isPresentIsoCodeAndPattern = function (control) {
        return control.parent && control.parent.get('isoCountry').valid ? null : { isoCountry: true };
    };
    MappingComponent.prototype.ngOnChanges = function () {
        this.active && this.disableAll();
    };
    return MappingComponent;
}());
export { MappingComponent };
